.windowViewBody {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  padding: 10px;
  gap: 8px;
  position: relative;
}

.windowViewLine {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2px;
  border-bottom: 1px solid #e0e0e0;
}

.height,
.noHeight {
  transition:
    min-height 0.5s ease-in-out,
    max-height 0.5s ease-in-out,
    opacity 0.5s ease-in-out;
}

.height {
  max-height: 500px;
  overflow: auto;
  opacity: 1;
}

.noHeight {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
}

.windowViewBlock.height,
.windowViewBlock.noHeight {
  margin-left: 32px;
}

.windowViewLineTitle {
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
  color: #222;
}

.windowViewBlock {
  display: flex;
  line-height: 16px;
  flex-direction: row;
  gap: 10px;
  align-items: left;
  padding: 4px 4px 4px 20px;
}
